import type {
  Cashier,
  CreateUpdateCashierRequest,
} from "@/services/sharedTypes/cashiers"
import api from "@/services/api"
import { queryClient } from "@/queryClient"
import { BASE_CASHIERS_QUERY_KEY } from "@/services/queryKeys"

export const updateCashier = async (
  cashierId: string,
  params: CreateUpdateCashierRequest
): Promise<Cashier> => {
  const response = await api.put<Cashier>(
    `/cashiers/${cashierId}`,
    {
      body: params,
    }
  )

  queryClient.invalidateQueries({
    queryKey: [BASE_CASHIERS_QUERY_KEY],
  })

  return response.body
}
